/* Bear Baby Boutique – gedrag van header, megamenu en mobiel menu.
   Megamenu: opent bij hover (150 ms) en bij klik, Enter of Spatie (native <details>); sluit bij
   Escape (focus terug), klik buiten het menu, muis buiten header en paneel, of het openen van
   een ander hoofditem. Drawer: accordeon met maximaal één open blok; bij openen staan alle
   blokken dicht behalve de huidige categorie. Dawn regelt openen/sluiten van de drawer zelf. */
(() => {
  if (window.bbHeaderBound) return;
  window.bbHeaderBound = true;

  const HOVER_DELAY = 150;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Megamenu ---------- */
  const wrapper = document.querySelector('.header-wrapper');
  const menus = Array.from(document.querySelectorAll('header-menu.bb-nav__menu'));

  const closeAll = (except) => {
    menus.forEach((menu) => {
      const details = menu.querySelector('details.bb-mega');
      if (details && details !== except && details.open) details.open = false;
    });
  };

  menus.forEach((menu) => {
    const details = menu.querySelector('details.bb-mega');
    const summary = details && details.querySelector('summary');
    if (!details || !summary) return;
    let hoverTimer = null;

    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(details.open));
      if (details.open) closeAll(details);
    });

    if (canHover.matches) {
      menu.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (!details.open) details.open = true;
        }, HOVER_DELAY);
      });
      menu.addEventListener('mouseleave', () => clearTimeout(hoverTimer));
    }

    details.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape' || !details.open) return;
      details.open = false;
      summary.focus();
    });
  });

  if (wrapper && menus.length) {
    wrapper.addEventListener('mouseleave', () => {
      if (canHover.matches) closeAll();
    });
    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) closeAll();
    });
  }

  /* ---------- Drawer-accordeon ---------- */
  const drawer = document.querySelector('.bb-drawer');
  if (drawer) {
    const buttons = Array.from(drawer.querySelectorAll('.bb-drawer__summary[aria-controls]'));
    const setOpen = (button, open) => {
      button.setAttribute('aria-expanded', String(open));
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !open;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        buttons.forEach((other) => {
          if (other !== button) setOpen(other, false);
        });
        setOpen(button, !isOpen);
      });
    });

    const container = document.getElementById('Details-menu-drawer-container');
    const toggle = container && container.querySelector('summary.bb-drawer__toggle');
    if (container && toggle) {
      container.addEventListener('toggle', () => {
        toggle.setAttribute('aria-label', container.open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
        if (container.open) {
          buttons.forEach((button) => setOpen(button, button.classList.contains('is-current')));
        }
      });
    }
  }
})();
